import { render, staticRenderFns } from "./chainSupplierTree.vue?vue&type=template&id=0edd6887&scoped=true"
import script from "./chainSupplierTree.vue?vue&type=script&lang=js"
export * from "./chainSupplierTree.vue?vue&type=script&lang=js"
import style0 from "./chainSupplierTree.vue?vue&type=style&index=0&id=0edd6887&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edd6887",
  null
  
)

export default component.exports